import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useMemo} from 'react';
import {runFileElementInteractionsSelector} from '../store/selectors/runfile.selectors';
import {currentSlideIndexSelector, visibleSlideSelector} from '../store/selectors/presentation.selectors';
import {filterAndSortMobileElements} from './presentation';
import {questionElementTypes} from '../incase-domain/elements/base/ElementTypes';
import {QuestionElementInteractions, YesNoElementInteractions} from '../incase-domain/proptypes/runfile';
import {setActiveMobileQestionAction} from '../store/actions/presentation.actions';
import {IElementQuestionnaire} from '../incase-domain/elements/base/questionElementBase';

export const useCurrentMobileQuestion = (): IElementQuestionnaire | undefined => {
    const dispatch = useDispatch();

    const elementInteractionsBySlide = useSelector(runFileElementInteractionsSelector);
    const slides = useSelector(visibleSlideSelector);
    const currentSlideIndex = useSelector(currentSlideIndexSelector);

    const currentSlide = useMemo(() => {
        return slides ? slides[currentSlideIndex] : undefined;
    }, [slides, currentSlideIndex]);

    const slideQuestions = useMemo(() => {
        return currentSlide
            ? filterAndSortMobileElements(currentSlide.elements.filter((element) => questionElementTypes.includes(element.type)))
            : [];
    }, [currentSlide]);

    const currentQuestion: IElementQuestionnaire | undefined = useMemo(() => {
        if (!slideQuestions.length) return undefined;

        return slideQuestions?.find((element) => {
            const slideElementInteractions = elementInteractionsBySlide ? elementInteractionsBySlide[element.slideId] : {};
            let elementInteractions: QuestionElementInteractions | YesNoElementInteractions = {} as
                | QuestionElementInteractions
                | YesNoElementInteractions;
            if (slideElementInteractions && slideElementInteractions[element.id]) {
                elementInteractions = slideElementInteractions[element.id] as QuestionElementInteractions | YesNoElementInteractions;
            }

            return !elementInteractions.answered;
        }) as IElementQuestionnaire | undefined;
    }, [slideQuestions, elementInteractionsBySlide]);

    useEffect(() => {
        dispatch(setActiveMobileQestionAction(currentQuestion?.id));
    }, [currentQuestion?.id, dispatch]);

    return currentQuestion;
};
